module.exports = __webpack_public_path__ + "static/media/picnic.981ddd5a.jpg";